import api from './apiHelper';

export const getPartnerListingHosts = () => api.get('partnerListing/hosts');

export const getPartnerListingBuildings = () => api.get('partnerListing/buildings');
